import { forwardRef } from "react";
import { useState } from "react";
import { useImperativeHandle } from "react";

import ReactSignatureCanvas from "react-signature-canvas";

export const ESignature = forwardRef(({ setSignature }, ref) => {
  const [sign, setSign] = useState();

  const clearSign = () => {
    sign.clear();
  };

  const saveSignHandle = () => {
    setSignature(sign.getTrimmedCanvas().toDataURL("image/png"));
  };

  useImperativeHandle(ref, () => ({
    clearHandler() {
      clearSign();
    },
    saveSign() {
      saveSignHandle();
    },
  }));

  return (
    <>
    <div style={{border:'1px solid #37373A'}}>
      <ReactSignatureCanvas
        ref={(data) => {
          setSign(data);
        }}
        canvasProps={{ width: "300px", height: "300px" }}
      />
      </div>
    </>
  );
});
